<template>
  <div class="DieselMonitorOverviewGraph1" ref="ui">
    <div class="graphs" id="lefttupu">
      <div class="ingraphs" v-if="overviewType === '传统概貌图'" ref="needmid"  :style="{height: mapheight,backgroundColor: nowImageBackground, width:'100%'}"  id="midtupu" >
        <UnitOverviewGrap ref="unitOverview" :nowtimeStatic="nowtimeStatic" :getScrollValue="getScrollValue" @graphImageBackground="graphImageBackground"
                          @gomid="gomid" @imageWidth="imageWidth" @imageheight="imageheights" @changthispostion='changthispostion'
                          @dataloading="dataloading" @datasuccess ="datasuccess"
                          @datanull="datanull" @datafail="datafail"></UnitOverviewGrap>
      </div>

      <OverViewIframe
        v-if="overviewType !== '传统概貌图'"
        :overviewType="overviewType"
        :mapheight="mapheight"
        :initequid="initequid"
      >
      </OverViewIframe>

      <!--     <div class="imgs"> <img  :src="'data:image/png;base64,'+this.codeBase" alt=""   :style="{width:'100%',height:mapheight}"></div>-->
      <div class="divGraph" :style="{height: graphheight}">
        <TrendGraph ref='trendg' v-show="show" @dataZoom="dataZoom" @reDataZoom="reDataZoom"
                    @chartinfo="chartinfo" @iscan="myiscan"
                    @refine="refine" @cancelRefine="cancelRefine" @historyInformation="historyInformation" :nowtimeStatic="nowtimeStatic"></TrendGraph>
      </div>
    </div>

    <!--  隐藏操作页按钮  -->
    <OpHideButton
      :showOpPage="showOpPage"
      @updateShowOpPage="updateShowOpPage">
    </OpHideButton>


    <div class='OpPage' v-show="showOpPage">
      <ReciprocatMachineryOverviewOpPage
        @static="nowstatic"
        @cleanChart="clearchart"
        @showgraph="showgraph"
        @overviewChange="overviewChange"
        @notshowgraph="notshowgraph"
        @DramHistoryGrap="iDramHistorygrap"
        @DramOtherHistoryGrap="iDramotherHistoryGrap"
        @DramPistonHistoryGrap="iDramPistonHistoryGrap"
        @DrawrealGrap="Drawrealgrap"
        @AddrealGrap="Addrealgrap"
        @DrawoutherrealGrap="iDrawoutherrealGrap"
        @AddoutherrealGrap="AddoutherrealGrap"
        @DrawPistonrealGrap="iDrawPistonrealGrap"
        @AddPistonrealGrap="AddPistonrealGrap"
        @getCancelrefinetime="getCancelrefinetime"
        ref="opPage"
      ></ReciprocatMachineryOverviewOpPage>
    </div>

  </div>
</template>

<script>
import UnitOverviewMapOpPage from "../../components/UnitOverviewMap/UnitOverviewMapOpPage";
import TrendGraph from "../../components/ComUtils/TrendGraph";
import UnitOverviewGrap from "../../components/ComUtils/UnitOverviewGrap";
import ReciprocatMachineryOverviewOpPage
  from "../../components/ReciprocatMachineryOverviewOpPage/ReciprocatMachineryOverviewOpPage";
import FrequencyMultiplicationSelectVue from '../../components/RotatingMachineryThreeDimensionalHolography/FrequencyMultiplicationSelect.vue';
import keyPressSignalMixin from '@/mixins/keyPressSignalMixin'
import OverViewIframe from "@/components/ComUtils/OverViewIframe";
import {timestampToTimeFormat} from "../../components/ComUtils/TimeFormat";
import OpHideButton from "@/components/ComUtils/OpHideButton";

export default {
  mixins: [keyPressSignalMixin],
  name: "OverviewGraph",
  components: {ReciprocatMachineryOverviewOpPage, UnitOverviewGrap, TrendGraph, UnitOverviewMapOpPage, OverViewIframe, OpHideButton},
  data() {
    return {
      lastpointsid:null,
      // 默认值
      overviewType: '',
      // imageWidths:0,
      // nowimageheights:0,
      imageWidths:10,
      nowimageheights:10,
      imageheight: '',
      // imageWidth: '',
      equipmentsName: '',
      time: '',
      revInfo: {
        revName: '',
        revValue: '',
      },
      nowtime:0,
      zoomDataIntervalBegin:[],
      zoomDataIntervalEnd:[],
      codeBase: '',
      graphDataTime: '',
      cancel:null,///cancelRefineAxios
      cancelAlarmLineAxios:null,
      show: false,
      mapheight: '100%',
      graphheight: '0%',
      unitname: '燃气发动机专用图谱-机组概貌图',
      onlyname: '',
      onlyone: 0,
      nowtree: null,
      Type:null,
      chartdata: null,
      myinterval: null,
      nowpointid: null,
      tongdao: null,
      graphtype: null,
      intervalflag: 0,
      backmap: null,
      textmap: null,
      colormap: null,
      nowdata: null,
      showOpPage: true,
      nowtimeStatic: null,
      rev: null,
      nowImageBackground:'',
      myinterval2:null,
      iscan:false,
      //细化
      lastpointIdString:null,
      lastfeature:null,
      stime1:null,
      etime1:null,
      realVibrationQuestFlag: false, //振动测点首次数据是否请求完成
      realVibrationQuest: true, //振动测点实时数据请求
      realOtherQuestFlag: false, //工艺量测点首次数据是否请求完成
      realOtherQuest: true, //工艺量测点实时数据请求
      realPistonQuestFlag: false, //动态压力、活塞杆首次数据是否请求完成
      realPistonQuest: true, //动态压力、活塞杆实时数据请求
      threeDimensionalOverviewIP: this.changeUrl(this.$store.state.threeDimensionalOverviewIP),
      initequid: this.$store.state.equid
    }
  },
  created() {
    if(this.$store.state.OverviewDisplayMode == 1){
      if(this.$store.state.showOverview){
        this.overviewType = "传统概貌图"
      }else if(this.$store.state.showEquipment){
        this.overviewType = "设备概貌图"
      }else if(this.$store.state.showProcess){
        this.overviewType = "工艺流程图"
      }
    }else{
      this.overviewType = '设备概貌图'
    }
    var mymap = new Map();
    mymap.set('0', "#FFE4C4");
    mymap.set('1', "#00FFFF");
    mymap.set('2', "#4B0082");
    mymap.set('3', "#F0E68C");
    mymap.set('4', "#778899");
    mymap.set('5', "#7B68EE");
    mymap.set('6', "#FF0000");
    mymap.set('7', "#FFFAFA");
    mymap.set('8', "#008080");
    mymap.set('9', "#FA8072");
    mymap.set('10', "#D3D3D3");
    mymap.set('11', "#FFFFE0");
    this.colormap = mymap;
    mymap = new Map();
    mymap.set('0', "通频");
    mymap.set('1', "1倍频幅值");
    mymap.set('2', "2倍频幅值");
    mymap.set('3', "3倍频幅值");
    mymap.set('4', "1/2倍频幅值");
    mymap.set('5', "残振");
    mymap.set('6', "直流量");
    mymap.set('7', "间隙电压");
    mymap.set('8', "1倍频相位");
    mymap.set('9', "2倍频相位");
    mymap.set('10', "3倍频相位");
    mymap.set('11', "1/2倍频相位");
    this.textmap = mymap;
    mymap = new Map();
    mymap.set("0", 'all');
    mymap.set("1", 'one');
    mymap.set("2", 'two');
    mymap.set("3", 'three');
    mymap.set("4", 'half');
    mymap.set("5", 'res');
    mymap.set("6", 'dc');
    mymap.set("7", 'gap');
    mymap.set("8", 'phaseOne');
    mymap.set("9", 'phaseTwo');
    mymap.set("10", 'phaseThree');
    mymap.set("11", 'phaseHalf');
    this.backmap = mymap;

  },
  computed: {
    overviewDisplayMode(){
      return this.$store.state.OverviewDisplayMode
    },
    ProcessOverviewIP() {
      return this.changeUrl(this.$store.state.ProcessOverviewIP);
    },

    show1() {
      return Number(this.showOpPage) + Number(this.$store.state.showOp);
    },
    getequName() {
      return this.$store.state.equName;
    },
    equid() {
      return this.$store.state.equid;
    },
    features() {
      return this.$store.state.features;
    },
    topiccolor() {
      return this.$store.state.topiccolor;
    },
    uid() {
      return this.$store.state.uid;
    },
    username() {
      return this.$store.state.username;
    },
    theme(){
      if (this.$store.state.topiccolor === 'white' || this.$store.state.topiccolor === 'simple-white'){
        return 'light'
      }else {
        return 'dark'
      }
    }
  },
  mounted() {
    this.$emit('changename', this.unitname);
    this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
    this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
    this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
    window.addEventListener('message', (event) => {
      if (event.data.type == 'redirect' && event.data.pointId && event.data.url) {
        this.$store.state.pointId = event.data.pointId
        this.$store.state.globalPointId = event.data.pointId
        let path = event.data.url
        this.$router.push({path: path, query: {equipmentUuid: this.$store.state.equid, topic: this.$store.state.topiccolor, language: this.$store.state.language}});
      }
    }, false)
    // console.log("往复啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊");
    // console.log(this.equid);
    //  this.getImage(this.equid);
  },
  beforeDestroy (){
    if (typeof this.cancel == 'function') {
      this.cancel()
    }
    // console.log('beforeDestroy')
    if(this.myinterval) {
      clearInterval(this.myinterval)
    }
    if(this.myinterval2) {
      clearInterval(this.myinterval2)
    }
  },
  destroyed() {
    if (typeof this.cancel == 'function') {
      this.cancel()
    }
    if(this.myinterval) {
      clearInterval(this.myinterval)
    }
    if(this.myinterval2) {
      clearInterval(this.myinterval)
    }
  },
  watch:{
    overviewDisplayMode(val){
      if(val == 1){
        if(this.$store.state.showOverview){
          this.overviewType = "传统概貌图"
        }else if(this.$store.state.showEquipment){
          this.overviewType = "设备概貌图"
        }else if(this.$store.state.showProcess){
          this.overviewType = "工艺流程图"
        }
      }else{
        this.overviewType = '设备概貌图'
      }
    },
    show1() {
      // console.log('问题在这',this.showOpPage ,this.$store.state.showOp)
      // if(this.showOpPage == true && this.$store.state.showOp == true){
      //   this.newwid = (window.screen.width - 600) + 'px'
      // }
      // else if(this.showOpPage == false &&  this.$store.state.showOp == true){
      //   this.newwid = (window.screen.width - 250) + 'px'
      // }
      // else if(this.showOpPage == true &&  this.$store.state.showOp == false) {
      //   this.newwid = (window.screen.width - 310) + 'px'
      // }
      // else {
      //   this.newwid = (window.screen.width - 80) + 'px'
      // }
    },
    topiccolor(val) {
      this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
      this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
      this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
    },
    equid(val) {
      console.log('iframe', this.$refs.iframe);
      // this.$refs.iframe.contentWindow.postMessage(val, `${this.threeDimensionalOverviewIP}`)
      if (this.$route.path == '/DieselMonitorSystem/OverviewGraph' && this.overviewType == '3D图') {
        this.$refs.iframe.contentWindow.postMessage(val, `${this.threeDimensionalOverviewIP}`)
      }
    },
  },

  methods: {
    dataZoom(zoomBegin,zoomEnd){
      if ( zoomBegin != null && zoomEnd != null){
        if (this.show==true){
          if (this.zoomDataIntervalBegin.length === 0){
            this.zoomDataIntervalBegin = this.$refs.trendg.mychart.getOption().useDataZoomBegin
            this.zoomDataIntervalEnd = this.$refs.trendg.mychart.getOption().useDataZoomEnd
          }
          this.$refs.trendg.dataZoom(zoomBegin,zoomEnd)
        }
        // console.log("测试reZoomData this.$refs.trends.length",this.$refs.trendgs.length)

        this.zoomDataInterval(zoomBegin,zoomEnd)
      }
    },
    reDataZoom(){
      // console.log("测试，最外层reDataZoom111", this.$refs.trendg.mychart.getOption().OriginalSeries[0].data);
      if (this.zoomDataIntervalBegin.length > 1){ // 最少保证有两个数据才能缩放，因为是先删除最后一个数据才开始放大还原
        this.zoomDataIntervalBegin.pop()
        this.zoomDataIntervalEnd.pop()
      }else {
        // 如果没有开始和结束时间，则直接结束方法
        return;
      }
      let flag=this.zoomDataIntervalBegin.length===1;
      if (this.show===true){
        let reOriginalSeries = JSON.parse(JSON.stringify(this.$refs.trendg.mychart.getOption().OriginalSeries))
        let reOption = JSON.parse(JSON.stringify(this.$refs.trendg.mychart.getOption()))
        this.$refs.trendg.reDataZoom(reOriginalSeries,reOption,this.zoomDataIntervalBegin[this.zoomDataIntervalBegin.length - 1],this.zoomDataIntervalEnd[this.zoomDataIntervalEnd.length - 1],flag)
      }
    },
    zoomDataInterval(zoomBegin,zoomEnd){
      if (this.zoomDataIntervalBegin[this.zoomDataIntervalBegin.length - 1] != zoomBegin ||
        this.zoomDataIntervalEnd[this.zoomDataIntervalEnd.length - 1] != zoomEnd){
        this.zoomDataIntervalBegin.push(zoomBegin)
        this.zoomDataIntervalEnd.push(zoomEnd)
      }
    },
    reDataZoomInterval(){
      this.zoomDataIntervalBegin = []
      this.zoomDataIntervalEnd = []
    },
    updateShowOpPage(val) {
      this.showOpPage = val;
    },
    overviewChange(type) {
      console.log("happen->需要切换概貌图", type)
      this.overviewType = type
    },
    getScrollValue(){
      let value = [this.$refs.needmid.scrollLeft,this.$refs.needmid.scrollTop,this.$refs.needmid.scrollWidth,this.$refs.needmid.scrollHeight]
      // console.log("测试是否执行获取滚轮偏移值的方法",value)
      return value
    },
    getline(equid,pointid) {
      var tmp_data= null;
      let mypointid = encodeURIComponent(encodeURIComponent(pointid));

      let isCancel = false;
      let CancelToken = this.$axios.CancelToken;
      var url = `point/${encodeURIComponent(equid)}/${mypointid}/alarmLine`
      if (typeof this.cancelAlarmLineAxios == 'function') {
        isCancel = true
        this.cancelAlarmLineAxios()

      }

      this.$axios.get(url,
        {
          cancelToken: new CancelToken((c) => {
            // executor 函数接收一个 cancel 函数作为参数
            this.cancelAlarmLineAxios = c;
          })}
      ).then(
        res => {
          if(res.data.code == 200) {
            //   console.log('line data', res.data.data)
            var lines = res.data.data;
            tmp_data = []
            if(lines.judgeAlarmType == 0) {
              tmp_data.push({
                name:'高报',
                yAxis:lines.alarmHigh
              })
              tmp_data.push({
                name:'高高报',
                yAxis:lines.alarmHighHigh
              })
            }
            else if(lines.judgeAlarmType == 1) {
              tmp_data.push({
                name:'低报',
                yAxis:lines.alarmLow
              })
              tmp_data.push({
                name:'低低报',
                yAxis:lines.alarmLowLow
              })
            }
            else {
              tmp_data.push({
                name:'高报',
                yAxis:lines.alarmHigh
              })
              tmp_data.push({
                name:'高高报',
                yAxis:lines.alarmHighHigh
              })
              tmp_data.push({
                name:'低报',
                yAxis:lines.alarmLow
              })
              tmp_data.push({
                name:'低低报',
                yAxis:lines.alarmLowLow
              })
            }
            this.$refs.trendg.aline = tmp_data;
          }

        }
      );
    },
    cleanunit() {
      let that =this;
      that.$refs.unitOverview.clearinterval();
    },
    myiscan(val) {
      this.iscan = val
      // alert(val)

      if (this.overviewType === "传统概貌图"){
        if(val == true) {
          this.cleanunit();
        }
        else {
          this.cleanunit();
          this.setinterval();
        }
      }

    },
    setinterval() {
      let that = this;
      setTimeout(() => {
        that.$refs.unitOverview.addgraphinformation(this.equid);
      }, 1000)
    },
    chartinfo(data) {

      // alert(this.iscan)
      if(this.iscan == true) {
        if (this.overviewType === '传统概貌图'){
          this.cleanunit();
        }
        this.historyInformation(data);
      }
      else {

      }
    },

    changthispostion(imWidths,imHeights) {
      // alert(document.getElementById("midtupu").clientWidth)
      if(imWidths>document.getElementById("midtupu").clientWidth){
        this.$refs.needmid.scrollLeft = (imWidths-document.getElementById("midtupu").clientWidth)/2;
        //   this.$refs.needmid.scrollTop = 350;

      }
      if(imHeights>document.getElementById("midtupu").clientHeight){
        this.$refs.needmid.scrollTop = (imHeights-document.getElementById("midtupu").clientHeight)/2;


      }
    },

    imageWidth(args){

      var o = document.getElementById("midtupu");
      var w = o.clientWidth||o.offsetWidth;
      this.imageWidths=Number(args-w)/2;
      // this.imageWidths=(Number(args.split('px')[0])-w)/2;
      //  console.log('??1')
      //  console.log(args)
      //  console.log(w);
      //  console.log(  this.imageWidths)
    },
    imageheights(args){
      var o = document.getElementById("midtupu");
      var h = o.clientHeight||o.offsetHeight;

      this.nowimageheights=Number(args-h)/2;
      //console.log('??2')
      //this.nowimageheights=(Number(args.split('px')[0])-h)/2;
      // console.log(args);
      // console.log(h)
      // console.log( this.nowimageheights)
    },
    gomid() {
      //console.log('121212',this.imageWidths,this.nowimageheights)
      this.$refs.needmid.scrollTo(this.imageWidths,0)
    },
    graphImageBackground(val){
      this.nowImageBackground=val;

    },

    //图谱细化
    refine(stime,etime){
      // console.log(this.nowtree);
      // console.log('开始细化')
      if( this.nowtree[0].id=="振动测点"){
        // console.log('啊啊啊啊啊',this.nowpointid,this.lastpointIdString, stime, etime,  this.nowtree, this.lastfeature,this.Type)
        this.DramHistorygrap( this.nowpointid,this.lastpointIdString, stime, etime,  this.nowtree, this.lastfeature,this.Type)
      }else if(this.nowtree[0].id=="温度" ||this.nowtree[0].id=="撞击"){
        this.DramotherHistoryGrap( this.nowpointid,this.lastpointIdString, stime, etime,  this.nowtree, this.lastfeature)
      }else if(this.nowtree[0].id=="活塞杆沉降/偏摆"){
        this.DramPistonHistoryGrap( this.nowpointid,this.lastpointIdString, stime, etime,  this.nowtree, this.lastfeature,this.Type)
      }
      this.reDataZoomInterval()
    },
    cancelRefine() {
      // 对于$store.state.startTime和endTime 由于存在清空操作 导致changeGraphData中没有进行x轴起止时间的插入
      // 所以对startTime和endTime进行赋值
      if(this.$store.state.startTime === '' || this.$store.state.endTime === '') {
        this.$store.state.startTime = this.stime1;
        this.$store.state.endTime = this.etime1;
      }
      if( this.nowtree[0].id=="振动测点"){
        // console.log('啊啊啊啊啊',this.nowpointid,this.lastpointIdString, stime, etime,  this.nowtree, this.lastfeature,this.Type)
        this.DramHistorygrap( this.nowpointid,this.lastpointIdString, this.stime1, this.etime1,  this.nowtree, this.lastfeature,this.Type)
      }else if(this.nowtree[0].id=="温度"||this.nowtree[0].id=="撞击"){
        this.DramotherHistoryGrap( this.nowpointid,this.lastpointIdString, this.stime1, this.etime1,  this.nowtree, this.lastfeature)
      }else if(this.nowtree[0].id=="活塞杆沉降/偏摆"){
        this.DramPistonHistoryGrap( this.nowpointid,this.lastpointIdString, this.stime1, this.etime1,  this.nowtree, this.lastfeature,this.Type)
      }
      this.reDataZoomInterval()
    },
    getCancelrefinetime(stime, etime){
      this.stime1=stime;
      this.etime1=etime;
    },

    nowstatic(data) {
      // console.log(data);
      // console.log('现在的钻沟')
      this.nowtimeStatic = data;    //实时为true  历史为false
      // console.log(this.$route.path);
      //    this.$store.commit('nowtimePath',this.$route.path );

    },
    historyInformation(myinfo) {
      var nowtime = this.handleClick(myinfo.name)
      var equipmentUuid1  = encodeURIComponent(this.equid );
      this.$store.state.gongyiOverviewIframeHistoryTime = nowtime;
      if (this.overviewType === "传统概貌图"){
        this.$emit('dataloading');
        // var pointIdString1  = encodeURIComponent(pointIdString);
        this.$axios.get("/graph/" + equipmentUuid1 + '/' + nowtime + "/historyData")
          .then(res => {
            //   console.log('0000000000000000');
            //  console.log(res)
            if (res.data.code === 200) {
              this.$emit('datasuccess');
              this.rev = res.data.data[0].trend.rev + 'r/min';
              //     console.log(this.rev)
              this.$refs.unitOverview.drawHistoryGraph(timestampToTimeFormat(nowtime), res.data.data, this.rev);
            }else {
              this.$emit('datafail');
            }
          });
      }

    },
    handleClick(getTimes) {//将当前时间转换为时间戳
      var date = new Date(getTimes);
      // 有三种方式获取
      // this.timestamp = date.getTime();//会精确到毫秒
      var time2 = date.valueOf();//会精确到毫秒
      return time2;
      // console.log(time2);//1398250549123
    },
    iDrawPistonrealGrap(equid, pointids, mytree, feautre, Type) {
      this.setinterval()
      this.DrawPistonrealGrap(equid, pointids, mytree, feautre, Type);
    },
    DrawPistonrealGrap(equid, pointids, mytree, feautre, Type){
      this.$emit('dataloading');
      this.nowtree = mytree;
      var textname = this.textmap.get(feautre.toString());
      this.onlyname = textname;
      var textstring = this.backmap.get(feautre.toString());
      this.onlyone = textstring;
      var equipmentUuid1  = encodeURIComponent(equid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


      let that = this;
      this.realPistonQuestFlag = false;
      this.$axios.get("/rodsink/" + equipmentUuid1 + "/" + pointIdString1 + "/real_time")
        .then(res => {
          if (res.data.code == 200) {
            this.$emit('datasuccess');
            this.realPistonQuestFlag = true;
            //   console.log(res);
            //    console.log('画1111111111111111111111111实时图谱');
            this.$emit('datasuccess');
            this.$emit('datasuccess');
            // let that = this;
            this.chartdata = res.data.data;
            // var title = this.chartdata.equipmentName + ' 实时';
            var title = that.features[Type][feautre].label;

            var newX = timestampToTimeFormat(this.chartdata.trendTime);

            var flagX = '[时间]';
            // var flagY = '[um]';
            var flagY = '[' + that.features[Type][feautre].unit + ']'
            var dataX = [];
            var dataY = [];
            dataX.push(newX);


            for (var i = 1; i < mytree.length; ++i) {
              var newY = this.chartdata.trendValue[i - 1][textstring];
              dataY.push({
                name: mytree[i].id,
                data: [newY],
                color: this.colormap.get(i.toString())
              })


            }
            if(dataX.length == 0) {
              this.$emit('datanull');
            }
            this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'real');

          }
          else{
            this.clearchart();
            this.$emit('datafail');
          }
        })/*.catch(e => {
          this.$emit('datafail');
        });*/


    },
    AddPistonrealGrap(equid, pointids){
      // alert(12344)
      if (this.realPistonQuestFlag && this.realPistonQuest) {
        this.realPistonQuest = false;
        var equipmentUuid1  = encodeURIComponent(equid );
        var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


        this.$axios.get("/rodsink/" + equipmentUuid1 + "/" + pointIdString1 + "/real_time")
          .then(res => {
            this.realPistonQuest = true;
            if (res.data.code === 200) {
              //  console.log(res);
              //  console.log('画实44444444444444444444444时图谱');
              let that = this;
              this.chartdata = res.data.data;
              var title = this.chartdata.equipmentName + ' 实时';

              var newX = timestampToTimeFormat(this.chartdata.trendTime);
              var dataY = [];
              for (var i = 1; i < this.nowtree.length; ++i) {
                var newY = this.chartdata.trendValue[i - 1][this.onlyone];
                dataY.push(newY);
              }
              this.$refs.trendg.changechart(newX, dataY);
              //  this.$refs.trendg.changechart(newX, dataY);

            }
            else{
              this.clearchart();
              this.$emit('datafail');
            }
          })
      }
      /*.catch(e => {
        this.$emit('datafail');
      });*/

    },
    iDramPistonHistoryGrap (equipmentUuid, pointIdString, stime, etime, mytree, feature,Type) {
      this.setinterval()
      this.DramPistonHistoryGrap(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type)
    },
    DramPistonHistoryGrap(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type){    //多测点历史没有数据
                                                                                                //   console.log(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type,"画乱七八糟历史")
      this.graphtype = '历史';
      this.$emit('dataloading');
      this.nowtree = mytree;
      this.nowpointid = equipmentUuid;
      this.lastpointIdString=pointIdString;
      this.lastfeature=feature;
      this.Type=Type;
      var textname = this.textmap.get(feature.toString());
      this.onlyname = textname;
      var textstring = this.backmap.get(feature.toString());
      this.onlyone = textstring;
      var equipmentUuid1  = encodeURIComponent(equipmentUuid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointIdString));
      this.getline(this.$store.state.equid,pointIdString.split(',')[0]);

      this.$refs.opPage.loadingStatus = true;
      var netinfor = '/rodsink/' + equipmentUuid1 + '/' + pointIdString1 + '/' + stime + '/' + etime + "/info";
      this.$axios.get(netinfor).then(res => {
        this.$refs.opPage.loadingStatus = false;
        if (res.data.code === 200) {
          //   console.log(res)
          this.$emit('datasuccess');
          this.chartdata = res.data.data;
          // console.log(this.features[Type][this.lastfeature].unit,'zzz')
          // var title = this.chartdata.equipmentName + ' 历史';
          var title = this.features[Type][this.lastfeature].label + ' '
          var trendinfo = this.chartdata.trendInfo;
          var flagX = '[时间]';
          var flagY = '[' +this.features[Type][this.lastfeature].unit + ']';
          var dataX = [];
          var dataY = [];
          var valueY = [];
          for (var i = 1; i < this.nowtree.length; ++i) {
            valueY.push([]);
          }
          let dataTime = '';
          let dayTime = 24 * 60 * 60 * 1000;
          if (trendinfo.length > 0) {
            dataTime = trendinfo[trendinfo.length - 1].trendTime - trendinfo[0].trendTime;
            dataTime = Math.ceil(dataTime / dayTime);
          }
          //  timestampToTimeFormat(this.chartdata.trendTime);
          // if(trendinfo.length > 0 && trendinfo[0].trendTime != stime) {
          //   dataX.push(timestampToTimeFormat(stime));
          //   let startTime = trendinfo[0].trendTime - stime;
          //   startTime = (startTime / dayTime);
          //   let num = Math.ceil(startTime / dataTime * trendinfo.length);
          //   let sUnitTime = parseInt((trendinfo[0].trendTime - stime) / num);
          //   // console.log(startTime, num);
          //   for(let _k = 1; _k < num; _k++) {
          //     let tmp = stime + sUnitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < trendinfo[0].trendTime) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   // for (var j = 1; j < this.nowtree.length; ++j) {
          //   //   for(let k = 0; k < num; k++) {
          //   //     valueY[j - 1].push(null);
          //   //   }
          //   // }
          // }
          for (var i = 0; i < trendinfo.length; ++i) {
            dataX.push(timestampToTimeFormat(trendinfo[i].trendTime));
            for (var j = 1; j < this.nowtree.length; ++j) {
              valueY[j - 1].push(trendinfo[i].trendValue[j - 1][this.onlyone])
            }
          }
          // if(trendinfo.length > 0 && trendinfo[trendinfo.length - 1].trendTime != etime) {
          //   let endTime = etime - trendinfo[trendinfo.length - 1].trendTime;
          //   endTime = (endTime / dayTime);
          //   let _num = Math.ceil(endTime / dataTime * trendinfo.length);
          //   let unitTime = parseInt((etime - trendinfo[trendinfo.length - 1].trendTime) / _num);
          //   // console.log(endTime, _num, unitTime, trendinfo[trendinfo.length - 1].trendTime + unitTime);
          //   for(let _k = 1; _k < _num; _k++) {
          //     let tmp = trendinfo[trendinfo.length - 1].trendTime + unitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < etime) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   dataX.push(timestampToTimeFormat(etime));
          //   // for (var j = 1; j < this.nowtree.length; ++j) {
          //   //   for(let k = 0; k < _num; k++) {
          //   //     valueY[j - 1].push(null);
          //   //   }
          //   // }
          // }
          console.log('我的横轴', dataX, dataY);
          if(dataX.length == 0) {
            this.$emit('datanull')
          }

          for (var i = 1; i < this.nowtree.length; ++i) {
            dataY.push({
              name: this.nowtree[i].id,
              data: valueY[i - 1],
              color: this.colormap.get(i.toString())
            })

          }
          if(dataX.length == 0) {
            this.$emit('datanull');
          }
           this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'history');
          // var myinfos = {trendTime: trendinfo[i].trendTime};
          //  this.historyInformation(myinfos);
        } else {
          this.clearchart();
          this.$emit('datafail')
          //this.$message.error(res.data.message);
        }
      })
        .catch(e => {
          this.$refs.opPage.loadingStatus = false;
          // this.clearchart();
          // this.$emit('datafail')
        });
    },
    iDrawoutherrealGrap(equid, pointids, mytree, feautre) {
      this.setinterval();
      this.DrawoutherrealGrap(equid, pointids, mytree, feautre)
    },
    DrawoutherrealGrap(equid, pointids, mytree, feautre) {
      //   console.log(equid, pointids, mytree, feautre);
      //   console.log('画实时图谱，我是传过来的数据');
      //  this.$refs.trendg.clearall();
      this.nowtree = mytree;
      this.$emit('dataloading');
      var equipmentUuid1  = encodeURIComponent(equid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


      this.realOtherQuestFlag = false;
      this.$axios.get("/proctrend/" + equipmentUuid1 + "/" + pointIdString1 + "/rt")
        .then(res => {
          if (res.data.code === 200) {
            this.$emit('datasuccess');
            this.realOtherQuestFlag = true;
            //  console.log(res);
            //   console.log('画实时图谱');
            this.chartdata = res.data.data;
            var firstdata = this.chartdata[this.nowtree[1].id];
            //  console.log(this.nowtree[1].id)
            // 初始化趋势图数据
            var flagX = '[时间]';
            var flagY = '['+firstdata.unit+']';
            var dataX = [];
            var dataY = [];
            // var title = this.$store.state.equName  + ' 实时';
            var title = '';
            dataX.push(timestampToTimeFormat(firstdata.time));
            for (var i = 1; i < this.nowtree.length; ++i) {
              dataY.push({
                name: this.nowtree[i].id,
                data: [this.chartdata[this.nowtree[i].id].value],
                color: this.colormap.get((i - 1).toString())
              })
            }
            if(dataX.length == 0) {
              this.$emit('datanull');
            }
            this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'real');
          }
          else{
            this.$emit('datafail');
          }
        })/*.catch(e => {
          this.$emit('datafail');
        });*/


    },
    //给其它图谱添加实时数据
    AddoutherrealGrap(equid, pointids) {

      if (this.realOtherQuestFlag && this.realOtherQuest) {
        this.realOtherQuest = false;
        var equipmentUuid1  = encodeURIComponent(equid );
        var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


        this.$axios.get("/proctrend/" + equipmentUuid1 + "/" + pointIdString1 + "/rt")
          .then(res => {
            this.realOtherQuest = true;
            if (res.data.code === 200) {
              this.$emit('datasuccess');
              this.chartdata = res.data.data;
              //   console.log(res);
              //   console.log('我是增加的图谱');
              var dataX = [];
              var dataY = [];
              dataX.push(timestampToTimeFormat(this.chartdata[this.nowtree[1].id].time));
              for (var i = 1; i < this.nowtree.length; ++i) {
                dataY.push(this.chartdata[this.nowtree[i].id].value)
              }
              this.$refs.trendg.changechart(dataX, dataY);
            }
            /* else{
              this.$emit('datafail');
            }*/
          })
      }
      /*.catch(e => {
        this.$emit('datafail');
      });*/


    },
    Drawrealgrap(equid, pointids, mytree, feautre, Type) {

      this.$emit('dataloading');
      this.tongdao = 0;
      this.graphtype = '实时'
      this.nowtree = mytree;
      // console.log(equid, pointids, mytree, feautre, Type,'aaaaaaaaaaaaaaaaaaaaaaaaaaaa');
      var textname = this.textmap.get(feautre.toString());
      this.onlyname = textname;
      var textstring = this.backmap.get(feautre.toString());
      this.onlyone = textstring;
      var CancelToken = this.$axios.CancelToken;
      let that = this;

      // if (typeof this.cancel == 'function') {
      //   this.cancel()
      // }

      var equipmentUuid1  = encodeURIComponent(equid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


      this.realVibrationQuestFlag = false;
      this.$axios.get("/trend/" + equipmentUuid1 + "/" + pointIdString1 + "/real_time")
        .then(res => {
          //   console.log('good')
          if (res.data.code === 200) {
            //  console.log(res.data)
            this.$emit('datasuccess');
            this.realVibrationQuestFlag = true;
            this.chartdata = res.data.data;
            // var title = this.chartdata.equipmentName + ' 实时';
            var title = that.features[Type][feautre].label;

            var newX = timestampToTimeFormat(this.chartdata.trendTime);

            var flagX = '[时间]';
            // var flagY = '[um]';
            var flagY = '[' + that.features[Type][feautre].unit + ']'
            var dataX = [];
            var dataY = [];
            dataX.push(newX);


            for (var i = 1; i < mytree.length; ++i) {
              var newY = this.chartdata.trendValue[i - 1][textstring];
              dataY.push({
                name: mytree[i].id,
                data: [newY],
                color: this.colormap.get(i.toString())
              })


            }
            if(dataX.length == 0) {
              this.$emit('datanull');
            }
            this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'real');

          } else {
            that.$emit('datafail')
            //this.$message.error(res.data.message);
          }
        }).catch(e => {
        this.clearchart();
        this.$emit('datafail')
      });
    },
    Addrealgrap(equid, pointids) {
      // var CancelToken = this.$axios.CancelToken;

      // if (typeof this.cancel == 'function') {
      //   this.cancel()
      // }
      console.log("Addrealgrap")
      console.log("kangkang",this.realVibrationQuestFlag, this.realVibrationQuest);
      if (this.realVibrationQuestFlag && this.realVibrationQuest) {
        this.realVibrationQuest = false;
        var equipmentUuid1  = encodeURIComponent(equid );
        var pointIdString1  = encodeURIComponent(encodeURIComponent(pointids));


        this.$axios.get("/trend/" + equipmentUuid1 + "/" + pointIdString1 + "/real_time").then(res => {
          this.realVibrationQuest = true;
          if (res.data.code === 200) {

            let that = this;
            this.chartdata = res.data.data;
            var title = this.chartdata.equipmentName + ' 实时';

            var newX = timestampToTimeFormat(this.chartdata.trendTime);
            var dataY = [];
            for (var i = 1; i < this.nowtree.length; ++i) {
              var newY = this.chartdata.trendValue[i - 1][this.onlyone];
              dataY.push(newY);
            }
            this.$refs.trendg.changechart(newX, dataY);

          } else {
            this.clearchart();
            this.$emit('datafail')
            //this.$message.error(res.data.message);
          }
        }).catch(e => {
          this.clearchart();
          this.$emit('datafail')
        });
      }

    },
    iDramHistorygrap(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type) {

      this.setinterval();
      this.DramHistorygrap(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type);
    },

    DramHistorygrap(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type) {

      this.$refs.trendg.iscan =false;
      // console.log(equipmentUuid, pointIdString, stime, etime, mytree, feature,Type,"画振动历史")
      this.graphtype = '历史';
      this.$emit('dataloading');
      this.nowtree = mytree;
      this.nowpointid = equipmentUuid;
      this.lastpointIdString=pointIdString;
      this.lastfeature=feature;
      this.Type=Type;
      // console.log(this.lastfeature)
      var textname = this.textmap.get(feature.toString());
      this.onlyname = textname;
      var textstring = this.backmap.get(feature.toString());
      this.onlyone = textstring;
      let that = this;
      // console.log(that.features[Type][this.lastfeature].unit,'111111111zzzzzzzzzzzz')
      var equipmentUuid1  = encodeURIComponent(equipmentUuid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointIdString));
      console.log('所有测点', pointIdString);
      this.getline(this.$store.state.equid,pointIdString.split(',')[0]);

      var netinfor = '/trend/' + equipmentUuid1 + '/' + pointIdString1 + '/' + stime + '/' + etime + "/info";
      var CancelToken = this.$axios.CancelToken;
      // debugger
      let isCancel = false
      if (typeof this.cancel == 'function') {
        this.cancel()
        isCancel = true
      }
      // debugger
      this.$refs.opPage.loadingStatus = true;
      this.$axios.get(netinfor,
        {
          cancelToken: new CancelToken((c) => {
            // executor 函数接收一个 cancel 函数作为参数
            this.cancel = c;
          })}

      ).then(res => {
        this.$refs.opPage.loadingStatus = false;
        if (res.data.code === 200 && res.data.data.trendInfo.length != 0) {
          //   console.log(res)
          this.$emit('datasuccess');

          this.chartdata = res.data.data;
          var title = that.features[Type][this.lastfeature].label + ' ';
          var trendinfo = this.chartdata.trendInfo;
          var flagX = '[时间]';
          var flagY = '[' +that.features[Type][this.lastfeature].unit + ']';
          var dataX = [];
          var dataY = [];
          var valueY = [];
          for (var i = 1; i < this.nowtree.length; ++i) {
            valueY.push([]);
          }
          //  timestampToTimeFormat(this.chartdata.trendTime);
          // console.log('起止时间', stime, etime);
          let allTime = etime - stime;
          let dataTime = '';
          let dayTime = 24 * 60 * 60 * 1000;
          if (trendinfo.length > 0) {
            dataTime = trendinfo[trendinfo.length - 1].trendTime - trendinfo[0].trendTime;
            dataTime = Math.ceil(dataTime / dayTime);
          }
          // console.log(dataTime, dayTime);
          // if(trendinfo.length > 0 && trendinfo[0].trendTime != stime) {
          //   dataX.push(timestampToTimeFormat(stime));
          //   let startTime = trendinfo[0].trendTime - stime;
          //   startTime = (startTime / dayTime);
          //   let num = Math.ceil(startTime / dataTime * trendinfo.length);
          //   let sUnitTime = parseInt((trendinfo[0].trendTime - stime) / num);
          //   // console.log(startTime, num);
          //   for(let _k = 1; _k < num; _k++) {
          //     let tmp = stime + sUnitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < trendinfo[0].trendTime) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   // for (var j = 1; j < this.nowtree.length; ++j) {
          //   //   for(let k = 0; k < num; k++) {
          //   //     valueY[j - 1].push(null);
          //   //   }
          //   // }
          // }
          for (var i = 0; i < trendinfo.length; ++i) {
            dataX.push(timestampToTimeFormat(trendinfo[i].trendTime));
            for (var j = 1; j < this.nowtree.length; ++j) {
              valueY[j - 1].push(trendinfo[i].trendValue[j - 1][this.onlyone])
            }
          }
          // console.log(trendinfo[trendinfo.length - 1].trendTime);
          // if(trendinfo.length > 0 && trendinfo[trendinfo.length - 1].trendTime != etime) {
          //    let endTime = etime - trendinfo[trendinfo.length - 1].trendTime;
          //   endTime = (endTime / dayTime);
          //   let _num = Math.ceil(endTime / dataTime * trendinfo.length);
          //   let unitTime = parseInt((etime - trendinfo[trendinfo.length - 1].trendTime) / _num);
          //   // console.log(endTime, _num, unitTime, trendinfo[trendinfo.length - 1].trendTime + unitTime);
          //   for(let _k = 1; _k < _num; _k++) {
          //     let tmp = trendinfo[trendinfo.length - 1].trendTime + unitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < etime) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   dataX.push(timestampToTimeFormat(etime));
          //   // for (var j = 1; j < this.nowtree.length; ++j) {
          //   //   for(let k = 0; k < _num; k++) {
          //   //     valueY[j - 1].push(null);
          //   //   }
          //   // }
          // }

          for (var i = 1; i < this.nowtree.length; ++i) {
            dataY.push({
              name: this.nowtree[i].id,
              data: valueY[i - 1],
              color: this.colormap.get(i.toString())
            })

          }
          if(dataX.length == 0) {
            this.$emit('datanull');
          }
          // console.log('横轴数据', dataX, dataY);
          this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'history');
          // var myinfos = {trendTime: trendinfo[i].trendTime};
          //  this.historyInformation(myinfos);
        } else {
          this.clearchart();
          this.$emit('datafail')
          //this.$message.error(res.data.message);
        }
      })
        .catch(e => {
          if (isCancel == false){
            this.clearchart();
            this.$emit('datafail');
            this.$refs.opPage.loadingStatus = false;
          }

        });

    },
    iDramotherHistoryGrap(equipmentUuid, pointIdString, stime, etime, mytree, feature) {
      this.setinterval()
      this.DramotherHistoryGrap(equipmentUuid, pointIdString, stime, etime, mytree, feature)
      //  console.log('死掉了吗');
    },
    DramotherHistoryGrap(equipmentUuid, pointIdString, stime, etime, mytree, feature) {
      //  console.log(pointIdString, stime, etime, mytree, feature,"画其它历史");
      this.$emit('dataloading');
      this.graphtype = '历史';
      this.nowtree = mytree;
      this.lastpointIdString=pointIdString;
      this.lastfeature=feature;
      //   console.log(this.nowtree)
      this.nowpointid = equipmentUuid;
      var equipmentUuid1  = encodeURIComponent(equipmentUuid );
      var pointIdString1  = encodeURIComponent(encodeURIComponent(pointIdString));
      this.getline(this.$store.state.equid,pointIdString.split(',')[0]);

      var netinfor = '/proctrend/' + equipmentUuid1 + '/' + pointIdString1 + '/' + stime + '/' + etime + "/his";
      var CancelToken = this.$axios.CancelToken;
      // if (typeof this.cancel == 'function') {
      //   this.cancel()
      // }
      this.$refs.opPage.loadingStatus = true;
      this.$axios.get(netinfor).then(res => {
        this.$refs.opPage.loadingStatus = false;
        if (res.data.code === 200) {
          //    console.log(res)
          this.$emit('datasuccess');
          this.chartdata = res.data.data.trendValues;

          //排序
          var unordered = this.chartdata;
          const ordered = {};
          Object.keys(unordered).sort().forEach(function(key) {
            ordered[key] = unordered[key];
          });
          this.chartdata=ordered
          var x = Object.keys(this.chartdata);
          var y = Object.values(this.chartdata);
          //初始化趋势图
          var flagX = '[时间]';
          let flagY = `[${res.data.data.unit[0]}]`
          // var flagY;
          // if (this.nowtree[0].id == '动态压力') flagY = '[Kpa]'
          // else if (this.nowtree[0].id == '温度') flagY = '[℃]'
          // else  flagY = '[um]'
          var dataX = [];
          var dataY = [];
          let sFlag = false, eFlag = false;
          // var title = this.$store.state.equName + ' ' + ' 历史'
          var title = ' ';
          let dataTime = '';
          let dayTime = 24 * 60 * 60 * 1000;
          let num = '', _num = '';
          if (x.length > 0) {
            dataTime = new Date(x[x.length - 1]).getTime() - new Date(x[0]).getTime();
            dataTime = Math.ceil(dataTime / dayTime);
          }
          // console.log(x, stime);
          // if(x.length > 0 && new Date(x[0]).getTime() != stime) {
          //   dataX.push(timestampToTimeFormat(stime));
          //   let startTime = new Date(x[0]).getTime() - stime;
          //   startTime = (startTime / dayTime);
          //   num = Math.ceil(startTime / dataTime * x.length);
          //   let sUnitTime = parseInt((new Date(x[0]).getTime() - stime) / num);
          //   console.log(startTime, num);
          //   for(let _k = 1; _k < num; _k++) {
          //     let tmp = stime + sUnitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < new Date(x[0]).getTime()) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   sFlag = true;
          // }
          //添加 x轴数据
          for (var i = 0; i < x.length; i++) {
            dataX.push(x[i])
          }
          // if(x.length > 0 && new Date(x[x.length - 1]).getTime() != etime) {
          //   let endTime = etime - new Date(x[x.length - 1]).getTime();
          //   endTime = (endTime / dayTime);
          //   _num = Math.ceil(endTime / dataTime * x.length);
          //   let unitTime = parseInt((etime - new Date(x[x.length - 1]).getTime()) / _num);
          //   // console.log(endTime, _num, unitTime, trendinfo[trendinfo.length - 1].trendTime + unitTime);
          //   for(let _k = 1; _k < _num; _k++) {
          //     let tmp = new Date(x[x.length - 1]).getTime() + unitTime * _k;
          //     // console.log(tmp);
          //     if (tmp < etime) {
          //       dataX.push(timestampToTimeFormat(tmp));
          //     } else {
          //         // dataX.push('');
          //       }
          //   }
          //   dataX.push(timestampToTimeFormat(etime));
          //   eFlag = true;
          // }
          //添加y轴数据
          for (var i = 1; i < this.nowtree.length; ++i) {
            var nowcolor = this.colormap.get((i - 1).toString());
            var nowtext = this.nowtree[i].id;
            var newY = [];
            // if(sFlag) {
            //   for(let _j = 0; _j < num; _j++) {
            //     newY.push(null);
            //   }
            // }
            for (var j = 0; j < y.length; ++j) {
              var nownum = y[j][0][i - 1];
              if (this.nowtree.length == 2) {
                nownum = y[j][0];
              }
              newY.push(nownum);
            }
            // if(eFlag) {
            //   for(let _j = 0; _j < _num; _j++) {
            //     newY.push(null);
            //   }
            // }
            dataY.push({
              name: nowtext,
              data: newY,
              color: nowcolor
            })
          }
          console.log(dataX, dataY);
          if(dataX.length == 0) {
            this.$emit('datanull');
          }
          this.$refs.trendg.setchart(flagX, flagY, dataX, dataY, title, 'history');
        } else {
          this.clearchart();
          this.$emit('datafail')
          //this.$message.error(res.data.message);
        }
      })
        .catch(e => {
          this.clearchart();
          this.$emit('datafail');
          this.$refs.opPage.loadingStatus = false;
        });

    },

    showgraph() {
      // console.log("xianshi");
      this.show = true;
      this.mapheight =  '60%';
      this.graphheight = 'calc(40% - 4px)';
      this.$nextTick(() => {
        this.$refs.trendg.mychart.resize();
      })
    },

    notshowgraph() {
      this.show = false;
      this.mapheight = '100%';
      this.graphheight = '0%';
      this.$nextTick(() => {
        this.$refs.trendg.mychart.resize();

      })
    },
    dataloading() {

      this.$emit('dataloading');
    },
    datasuccess() {
      this.$emit('datasuccess')
    },
    datafail() {
      this.$emit('datafail')
    },
    datanull() {
      this.$emit('datanull')
    },
    stopnowinterval() {
      if (this.myinterval) {
        clearInterval(this.myinterval);
      }
    },

    cancelRequest() {
      if (typeof this.source === 'function') {
        this.source('终止请求')
      }
    },
    //时间戳处理
    // timestampToTime(timestamp) {
    //   var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    //   var Y = date.getFullYear() + '-';
    //   var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //   var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    //   var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    //   var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    //   var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
    //   //var nowtime = new Date(Y+M+D+h+m+s);
    //   var ms = (date.getTime() % 1000).toString();
    //   while (ms.length < 3) {
    //     ms = '0' + ms;
    //   }
    //   return Y + M + D + h + m + s + ms;
    // },

    openalarm() {
      this.$confirm('请选择测点', '提示', {
        cancelButtonText: '确定',
        type: 'warning'
      }).then(() => {
      }).catch(() => {
      });
    },

    clearchart() {
      var CancelToken = this.$axios.CancelToken;

      // if (typeof this.cancel == 'function') {
      //   this.cancel()
      // }
      this.$refs.trendg.clearall();

    },

  }
}
</script>

<style lang="scss">
.DieselMonitorOverviewGraph1 {
  --conbgcolor: #0D0F1F;
  --leftconbgcolor: #222331;
  --buttoncolor: #1677FF;
  --textcolor: #ffffff;
  background-color: var(--conbgcolor);
  width: 100%;
  height: 100%;
  display: flex;

  /*  .infromtion {
      position: relative;

      .equipmentName {
        // background-color: yellow;
        position: relative;
        z-index: 1;
        color: #fff;
        top: 90px;
        //  left: 40%;
        width: 200px;
        margin: 0 auto;
        text-align: center;
        font-size: 36px;
      }

      .equipmentTime {
        width: 200px;
        //  background-color: #67c23a;
        position: relative;
        z-index: 1;
        color: #fff;
        top: 90px;
        left: calc(50% - 150px);
        //  right: 50px;
        //   min-width: 290px;
        margin: 0 auto;
        // float: left;
        //  left: 400px;
        //   text-align: center;
      }

      .revInfo {
        width: 200px;
        position: relative;
        z-index: 1;
        color: #fff;
        //background-color: #3a8ee6;
        top: 100px;
        left: calc(50% - 150px);
        // right: 100px;
        //  min-width: 290px;
        margin: 0 auto;
        // float: left;
        // text-align: center;
      }
      .point_box {
        font-size: 12px;
        color: #ececec;
        position: absolute;
        border: 1px solid #fff;
        overflow: auto;
        list-style: none
      }
    }
*/
  .alarmStatus_2 {
    color: red; //危险
  }

  .alarmStatus_1 {
    color: yellow; //报警
  }

  .imgs {
    top: 5px;
    position: absolute;
    z-index: 0;
    height: 100%;
    width: 100%;

  }

  .ingraphs {
    overflow-x: auto;
    overflow-y: auto;
    background-color: var(--leftconbgcolor);
  }

  .graphs {
    margin: 10px 2px 0 2px;
    float: left;
    width: calc(100% - 300px);
    height: calc(100% - 10px);
  }
  ::-webkit-scrollbar{
    width:5px;
    height: 5px;
    background-color: #061d74;
  }
  ::-webkit-scrollbar-thumb{

    background-color: #646563;
  }

  .OpPage {
    width: 290px;
    height: calc(100% - 10px);
    margin-top: 10px;
    float: right;
    overflow: hidden;
    background-color: var(--leftconbgcolor);
  }

  .image {
    //  background-color: #67c23a;
  }

  .gmt {
    height: 747px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: left top;
  }

  .divGraph {
    width: 100%;
    margin-top: 4px;
  }
}

</style>



// WEBPACK FOOTER //
// src/Page/DieselMonitorSystem/OverviewGraph.vue